// src/json.ts
import SuperJSON from "superjson";
var serialize = {
  encode: (data) => {
    var _a;
    let sup = SuperJSON.serialize(data);
    if ((_a = sup.meta) == null ? void 0 : _a.referentialEqualities) {
      delete sup.meta.referentialEqualities;
    }
    return JSON.stringify({
      __types: {
        __mode: typeof sup.json == "object" ? "object" : "value",
        ...sup.meta
      },
      data: typeof sup.json != "object" ? sup.json : void 0,
      ...typeof sup.json == "object" ? sup.json : {}
    });
  },
  decode: (data) => {
    if (typeof data == "string")
      data = JSON.parse(data);
    let { __types, ...rest } = data;
    if (typeof __types != "object" || !__types.__mode)
      return data;
    let { __mode, ...meta } = __types;
    let json = __mode == "value" ? rest.data : rest;
    return SuperJSON.deserialize({ json, meta });
  }
};
export {
  serialize
};
//# sourceMappingURL=index.mjs.map